 

import React, { useState } from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "../../uiComps/Card";
import { Mail, Phone, MapPin, Clock, Send, Loader2, CheckCircle, User } from 'lucide-react';
import { Button, Input, Textarea, Select, SelectItem } from "../../uiComps/Utils";

export default function Contact() {
  const address = "101 Long Hill Rise, Hucknall, Nottingham, NG15 6GL";
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "Payroll",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitContact, setSubmitContact] = useState({ isPending: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitContact({ isPending: true });

    // Read all values from state
    const { name, email, phone, service, message } = formData;

    // Create JSON payload
    const payload = {
      name: name || "No Name",
      email: email || "No Email",
      phone: phone || "No Phone",
      service: service || "No Service",
      subject: `ENQUIRY - ${service} - ${name} - ${email}`,
  access_key: "0db93bc4-f97c-4ca7-8851-d55058303f62"
    };

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      
    } catch (err) {
      console.error("Submission error:", err);
    }

    // Reset form after submission
    setTimeout(() => {
      setSubmitted(true);
      setSubmitContact({ isPending: false });
      setFormData({
        name: "",
        email: "",
        phone: "",
        service: "Payroll",
        message: "",
      });
    }, 1500);
  };

  return (
    <section id="contact" className="py-24 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-amber-600 font-medium text-sm tracking-wider uppercase">
            Get In Touch
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-slate-900 mt-4 mb-6">
            Contact Us
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto font-light">
            Ready to take control of your finances? We'd love to hear from you.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Contact Info + Map */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-2 space-y-6"
          >
            <Card className="bg-gradient-to-br from-slate-800 to-slate-900 border-0 text-white overflow-hidden relative">
              <CardContent className="p-5 sm:p-6">
                <h3 className="text-2xl font-light mb-6 sm:mb-8">
                  Contact Information
                </h3>

                <div className="space-y-6">
                  <a
                    href="mailto:BKAccountants@hotmail.co.uk"
                    className="flex items-start gap-4 group"
                  >
                    <div className="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center shrink-0 group-hover:bg-amber-500/30 transition-colors">
                      <Mail className="w-5 h-5 text-amber-500" />
                    </div>
                    <div>
                      <p className="text-slate-400 text-sm">Email Us</p>
                      <p className="text-white font-medium group-hover:text-amber-400 transition-colors">
                        BKAccountants@hotmail.co.uk
                      </p>
                    </div>
                  </a>

                  <a
                    href={mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-4 group"
                  >
                    <div className="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center shrink-0 group-hover:bg-amber-500/30 transition-colors">
                      <MapPin className="w-5 h-5 text-amber-500" />
                    </div>
                    <div>
                      <p className="text-slate-400 text-sm">Visit Us</p>
                      <p className="text-white font-medium group-hover:text-amber-400 transition-colors">
                        101 Long Hill Rise
                        <br />
                        Nottingham, UK, NG15 6GL
                      </p>
                      <p className="text-amber-500 text-sm mt-1">
                        Click to open in Google Maps →
                      </p>
                    </div>
                  </a>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center shrink-0">
                      <Clock className="w-5 h-5 text-amber-500" />
                    </div>
                    <div>
                      <p className="text-slate-400 text-sm">Office Hours</p>
                      <p className="text-white font-medium">Mon - Fri: 9:00 - 17:00</p>
                    </div>
                  </div>
                </div>
                 <div className="border-t border-white/10 pt-6 space-y-4">
                    <p className="text-slate-400 text-sm">Direct Contact</p>
                    {[
                      { name: "Mrs Melanie Baker FCCA", phone: "0115 9636671" },
                      { name: "Mrs Nicola Kerry FCCA", phone: "0115 8409997" },
                    ].map((partner) => (
                      <div key={partner.name} className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-xl bg-amber-500/20 flex items-center justify-center shrink-0">
                          <User className="w-4 h-4 text-amber-500" />
                        </div>
                        <div>
                          <p className="text-white font-medium text-sm">{partner.name}</p>
                          <a href={`tel:${partner.phone.replace(/\s/g, '')}`} className="text-amber-400 hover:text-amber-300 transition-colors text-sm flex items-center gap-1 mt-0.5">
                            <Phone className="w-3 h-3" />
                            {partner.phone}
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>

              <div className="absolute -bottom-12 -right-12 w-40 h-40 rounded-full bg-amber-500/10" />
              </CardContent>
            </Card>

            <a
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-emerald-50 border border-emerald-200 rounded-2xl px-5 py-4 hover:bg-emerald-100 transition-colors group"
            >
              <div className="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-slate-800 font-medium text-sm">Open in Google Maps</p>
                <p className="text-slate-500 text-xs">Get directions to our office</p>
              </div>
              <span className="ml-auto text-emerald-600 group-hover:translate-x-1 transition-transform">→</span>
            </a>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-3"
          >
            <Card className="bg-white border-0 shadow-xl rounded-2xl overflow-hidden">
              <CardContent className="p-5 sm:p-8">
                {submitted ? (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="text-center py-12"
                  >
                    <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
                      <CheckCircle className="w-10 h-10 text-green-600" />
                    </div>
                    <h3 className="text-2xl font-medium text-slate-900 mb-2">
                      Message Sent!
                    </h3>
                    <p className="text-slate-600">We'll get back to you as soon as possible.</p>
                  </motion.div>
                ) : (
                  <>
                    <h3 className="text-2xl font-light text-slate-900 mb-6 text-left">
                      Send us a message
                    </h3>

                    <form onSubmit={handleSubmit} className="space-y-5">
                      <div className="grid md:grid-cols-2 gap-5">
                        <div>
                          <label className="text-slate-700 text-sm font-medium mb-2 block">
                            Your Name *
                          </label>
                          <Input
                            placeholder="John Smith"
                            value={formData.name}
                            type="text"
                            name="name"
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            required
                            className="bg-slate-50 text-slate-900 border-slate-200 focus:border-amber-500 focus:ring-amber-500"
                          />
                        </div>
                        <div>
                          <label className="text-slate-700 text-sm font-medium mb-2 block">
                            Email Address *
                          </label>
                          <Input
                            type="email"
                            name="email"
                            placeholder="john@example.com"
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            required
                            className="bg-slate-50 text-slate-900 border-slate-200 focus:border-amber-500 focus:ring-amber-500"
                          />
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 gap-5">
                        <div>
                          <label className="text-slate-700 text-sm font-medium mb-2 block">
                            Phone Number
                          </label>
                          <Input
                            type="tel"
                            name="phone"
                            placeholder="07123 456789"
                            value={formData.phone}
                            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                            className="bg-slate-50 text-slate-900 border-slate-200 focus:border-amber-500 focus:ring-amber-500"
                          />
                        </div>
                        <div>
                          <label className="text-slate-700 text-sm font-medium mb-2 block">
                            Service Required
                          </label>
                          <Select
                            name="service"
                            value={formData.service}
                            onValueChange={(value) =>
                              setFormData((prev) => ({ ...prev, service: value }))
                            }
                            placeholder="Select a service"
                            className="bg-slate-50 text-slate-900 border-slate-200 focus:border-amber-500 focus:ring-amber-500 text-slate-900"
                          >
                            <SelectItem value="Payroll">Payroll</SelectItem>
                            <SelectItem value="Sole Traders & Partnerships">
                              Sole Traders & Partnerships
                            </SelectItem>
                            <SelectItem value="VAT Returns">VAT Returns</SelectItem>
                            <SelectItem value="Limited Companies">Limited Companies</SelectItem>
                            <SelectItem value="Bookkeeping">Bookkeeping</SelectItem>
                          </Select>
                        </div>
                      </div>

                      <div>
                        <label className="text-slate-700 text-sm font-medium mb-2 block">
                          Your Message *
                        </label>
                        <Textarea
                          placeholder="Tell us about your requirements..."
                          value={formData.message}
                          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                          required
                          name="message"
                          rows={5}
                          className="bg-slate-50 text-slate-900 border-slate-200 focus:border-amber-500 focus:ring-amber-500 resize-none"
                        />
                      </div>

                      <Button
                        type="submit"
                        disabled={submitContact.isPending}
                        className="w-full bg-slate-900 hover:bg-slate-800 text-white py-6 text-lg font-medium rounded-xl transition-all duration-300 hover:shadow-lg"
                      >
                        {submitContact.isPending ? (
                          <Loader2 className="w-5 h-5 animate-spin" />
                        ) : (
                          <>
                            <Send className="w-5 h-5 mr-2" />
                            Send Message
                          </>
                        )}
                      </Button>
                    </form>
                  </>
                )}
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
}